import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-20" }
const _hoisted_4 = { class: "dropdown select-dropdown" }
const _hoisted_5 = {
  class: "dropdown-toggle border text-body rounded-2 bg-gray-100",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "default-table-area style-two campaigns-table px-20 py-12 latest-transactions-table" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle border-0" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "flex-shrink-0" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex-grow-1 ms-2" }
const _hoisted_15 = { class: "fs-14 fw-semibold mb-0" }
const _hoisted_16 = { class: "fs-12 fw-semibold text-body" }
const _hoisted_17 = { class: "fs-12 fw-semibold text-secondary" }
const _hoisted_18 = { class: "d-flex align-items-center gap-1" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "ms-2 text-secondary fs-12 fw-semibold" }
const _hoisted_21 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap mt-12" }
const _hoisted_22 = { class: "fs-12 fw-medium" }
const _hoisted_23 = { "aria-label": "Page navigation example" }
const _hoisted_24 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_25 = { class: "page-item" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "page-item" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "mb-0" }, "Latest Transactions", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.selectedPeriod), 1),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timePeriods, (period) => {
              return (_openBlock(), _createElementBlock("li", { key: period }, [
                _createElementVNode("button", {
                  class: "dropdown-item text-secondary py-2 px-3",
                  onClick: ($event: any) => (_ctx.selectedPeriod = period)
                }, _toDisplayString(period), 9, _hoisted_7)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "border-bottom" }, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-semibold letter-spacing-1" }, "CLIENT")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-semibold letter-spacing-1" }, "EMAIL")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-semibold letter-spacing-1" }, "AMOUNT")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-semibold letter-spacing-1" }, "PAYMENT METHOD")
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "bg-transparent"
                }, [
                  _createElementVNode("span", { class: "fs-10 text-body fw-semibold letter-spacing-1" }, "STATUS")
                ])
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedTransactions, (transaction) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: transaction.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("img", {
                          src: transaction.avatar,
                          class: "rounded-circle",
                          style: {"width":"32px","height":"32px"},
                          alt: "user"
                        }, null, 8, _hoisted_13)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("h4", _hoisted_15, _toDisplayString(transaction.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(transaction.email), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatCurrency(transaction.amount)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("img", {
                        src: transaction.paymentMethod.icon,
                        alt: transaction.paymentMethod.name
                      }, null, 8, _hoisted_19),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(transaction.paymentMethod.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["d-inline-block rounded-pill fs-12 fw-medium", _ctx.statusClasses(transaction.status)]),
                      style: {"padding":"1px 10px"}
                    }, _toDisplayString(transaction.status), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, " Showing " + _toDisplayString(_ctx.showingFrom) + "-" + _toDisplayString(_ctx.showingTo) + " of " + _toDisplayString(_ctx.transactions.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_23, [
            _createElementVNode("ul", _hoisted_24, [
              _createElementVNode("li", _hoisted_25, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, " keyboard_arrow_left ", -1)
                ]))], 8, _hoisted_26)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.currentPage = page)
                  }, _toDisplayString(page), 11, _hoisted_27)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_28, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, " keyboard_arrow_right ", -1)
                ]))], 8, _hoisted_29)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}